import {
  GenerateManualPayload_manual_generateManualPayload_skuPositions_values_value_placementInfoMap_markers,
} from '@src/app/generated/GenerateManualPayload';
import { Id, ModulePlacement, SpacialPosition, vectorFromRaw } from '@ess/jg-rule-executor';
import { IdModulePlacementListSpacialPositionInputInputMap } from '@src/app/generated/globalTypes';
import { PortalVector3 } from '@src/app/model/portalVector3';

export class PlacementInformation {
  spacialPosition: SpacialPosition;
  marker: string;

  constructor(
    spacialPosition: SpacialPosition,
    marker: string
  ) {
    this.spacialPosition = spacialPosition;
    this.marker = marker;
  }

  static fromGql(
    gql: GenerateManualPayload_manual_generateManualPayload_skuPositions_values_value_placementInfoMap_markers
  ): PlacementInformation {
    return new PlacementInformation(
      new SpacialPosition(
        gql.spacialPosition.position
          ? vectorFromRaw(PortalVector3.fromGql(gql.spacialPosition.position))
          : undefined,
        gql.spacialPosition.orientation
          ? vectorFromRaw(PortalVector3.fromGql(gql.spacialPosition.orientation))
          : undefined
      ),
      gql.marker
    );
  }

  static convertToPlacementInfoInput(
    placementsInfo: Map<Id<ModulePlacement>, SpacialPosition[]>
  ): IdModulePlacementListSpacialPositionInputInputMap {
    if (placementsInfo) {
      const keys = Array.from(placementsInfo.keys());
      return {
        values: keys.map((key) => {
          return {
            key: key,
            value: placementsInfo.get(key),
          };
        }),
      };
    } else {
      return null;
    }
  }
}
